import { useEffect, useState } from 'react';
import CheckBox from '../../../common/CheckBox';

export default function SmartStore() {
	const [TableData, setTableData] = useState({});
	const [IdList, setIdList] = useState([]);
	const [SiteList, setSiteList] = useState([]);
	const [DeliveryFeeTypeList, setDeliveryFeeTypeList] = useState([]);
	const [OptionList, setOptionList] = useState([]);
	const [RegistList, setRegistList] = useState([]);
	const [IsBundle, setIsBundle] = useState([]);
	const [IsIdDropBoxOpen, setIsIdDropBoxOpen] = useState(false);
	const [IsDeliveryDropBoxOpen, setIsDeliveryDropBoxOpen] = useState(false);

	const handleInputChange = (e, type) => {
		let updatedData = { ...TableData };
		if (type === 'id' || type === 'deliveryFeeType') {
			updatedData[type] = e.target.innerText;
		} else if (
			type === 'margin' ||
			type === 'marketCharge' ||
			type === 'setNameCharge' ||
			type === 'deliveryFee' ||
			type === 'jejuDeliveryFee' ||
			type === 'islandDeliveryFee' ||
			type === 'returnDeliveryFee' ||
			type === 'exchangeDeliveryFee'
		) {
			let newValue = e.target.value.replace(/[^0-9]/g, '');
			updatedData[type] = newValue;
		} else {
			updatedData[type] = e.target.value;
		}
		setTableData(updatedData);
	};

	const handleBlurContainer = (e, type) => {
		if (type === 'idDropBox') {
			const newValue = !IsIdDropBoxOpen;
			setTimeout(() => {
				setIsIdDropBoxOpen(newValue);
			}, 200);
		} else {
			const newValue = !IsDeliveryDropBoxOpen;
			setTimeout(() => {
				setIsDeliveryDropBoxOpen(newValue);
			}, 200);
		}
	};
	const handleSingleCheck = (e, type) => {
		let updatedData = { ...TableData };
		updatedData[type] = !TableData[type];
		setTableData(updatedData);
	};
	const handleMultiCheck = (checkedList, type) => {
		let updatedData = { ...TableData };
		updatedData[type] = checkedList;
		setTableData(updatedData);
	};
	const handleRadioChange = (e, type) => {
		let updatedData = { ...TableData };
		updatedData[type] = e.target.value;
		setTableData(updatedData);
	};

	useEffect(() => {
		//axios
		setIdList(['one', 'two', 'three']);
		setSiteList(['네이버쇼핑', '에누리', '다나와']);
		setDeliveryFeeTypeList(['유료', '무료']);
		setOptionList([
			{ value: 'single', label: '단일등록' },
			{ value: 'option', label: '옵션등록' },
		]);
		setRegistList([
			{ value: 'new', label: '신규등록' },
			{ value: 'modi', label: '수정등록' },
		]);
		setIsBundle([
			{ value: 'posi', label: '가능' },
			{ value: 'imposi', label: '불가능' },
		]);
		const defaultData = {
			allDiscount: false,
			buysDiscount: false,
			site: [],
			point: [],
			option: 'option',
			regist: 'modi',
			isBundle: 'imposi',
			deliveryFeeType: '유료',
		};
		setTableData(defaultData);
	}, []);
	return (
		<div className='SmartStore'>
			<div className='tamplate-table'>
				<table>
					<tbody>
						<tr>
							{/**세트명*/}
							<th>세트명</th>
							<td>
								<input type='text' onChange={(e) => handleInputChange(e, 'setName')} />
							</td>
						</tr>
						<tr>
							{/**아이디 선택*/}
							<th>아이디 선택</th>
							<td>
								<div className='container' onBlur={(e) => handleBlurContainer(e, 'idDropBox')} style={{ width: 200 }}>
									<label onClick={(e) => handleBlurContainer(e, 'idDropBox')}>
										<button className='dropdown-button'>
											<span>{TableData.id ? TableData.id : '===아이디 선택==='}</span>
											<span className='dropdown-button-arrow'>{IsIdDropBoxOpen ? '▲' : '▼'}</span>
										</button>
									</label>
									{IsIdDropBoxOpen && (
										<div className={IsIdDropBoxOpen ? 'dropdown-container open' : 'dropdown-container'}>
											<ul className='dropdown-content'>
												{IdList.map((el, idx) => (
													<li key={el + idx} onClick={(e) => handleInputChange(e, 'id')}>
														{el}
													</li>
												))}
											</ul>
										</div>
									)}
								</div>
							</td>
						</tr>
						<tr>
							{/**마진*/}
							<th>마진</th>
							<td>
								<input type='text' value={TableData.margin || ''} onChange={(e) => handleInputChange(e, 'margin')} />%
							</td>
						</tr>
						<tr>
							{/**마켓 수수료*/}
							<th>마켓 수수료</th>
							<td>
								<input type='text' value={TableData.marketCharge || ''} onChange={(e) => handleInputChange(e, 'marketCharge')} />%
							</td>
						</tr>
						<tr>
							{/**네이버 수수료*/}
							<th>네이버 수수료</th>
							<td>
								<input type='text' value={TableData.setNameCharge || ''} onChange={(e) => handleInputChange(e, 'setNameCharge')} />%
							</td>
						</tr>
						<tr>
							{/**옵션타입*/}
							<th>옵션타입</th>
							<td className='radioItem'>
								{OptionList.map((el, index) => (
									<label key={index} className={TableData.option === el.value ? 'on' : ''}>
										<input
											type='radio'
											name='option'
											value={el.value || ''}
											onChange={(e) => handleRadioChange(e, 'option')}
											checked={TableData.option && TableData.option === el.value}
										/>
										<span>{el.label}</span>
									</label>
								))}
							</td>
						</tr>
						<tr>
							{/**등록타입*/}
							<th>등록타입</th>
							<td className='radioItem'>
								{' '}
								{RegistList.map((el, index) => (
									<label key={index} className={TableData.regist === el.value ? 'on' : ''}>
										<input
											type='radio'
											name='regist'
											value={el.value || ''}
											onChange={(e) => handleRadioChange(e, 'regist')}
											checked={TableData.regist && TableData.regist === el.value}
										/>
										<span>{el.label}</span>
									</label>
								))}
							</td>
						</tr>
						<tr>
							{/**전체 할인*/}
							<th>전체 할인</th>
							<td>
								<label>
									<input
										type='checkbox'
										value={TableData.allDiscount}
										checked={TableData.allDiscount}
										onChange={(e) => {
											handleSingleCheck(e, 'allDiscount');
										}}
									/>
									<span>설정함</span>
								</label>
							</td>
						</tr>
						<tr>
							{/**배송비 종류*/}
							<th>배송비 종류</th>
							<td>
								<div className='container' onBlur={(e) => handleBlurContainer(e, 'deliveryFeeType')} style={{ width: 200 }}>
									<label onClick={(e) => handleBlurContainer(e, 'deliveryFeeType')}>
										<button className='dropdown-button'>
											<span>{TableData.deliveryFeeType}</span>
											<span className='dropdown-button-arrow'>{IsDeliveryDropBoxOpen ? '▲' : '▼'}</span>
										</button>
									</label>
									{IsDeliveryDropBoxOpen && (
										<div className={IsDeliveryDropBoxOpen ? 'dropdown-container open' : 'dropdown-container'}>
											<ul className='dropdown-content'>
												{DeliveryFeeTypeList.map((el, idx) => (
													<li key={el + idx} onClick={(e) => handleInputChange(e, 'deliveryFeeType')}>
														{el}
													</li>
												))}
											</ul>
										</div>
									)}
								</div>
							</td>
						</tr>
						<tr>
							{/**묶음 배송*/}
							<th>묶음 배송</th>
							<td className='radioItem'>
								{IsBundle.map((el, index) => (
									<label key={index} className={TableData.isBundle === el.value ? 'on' : ''}>
										<input
											type='radio'
											name='isBundle'
											value={el.value || ''}
											onChange={(e) => handleRadioChange(e, 'isBundle')}
											checked={TableData.isBundle && TableData.isBundle === el.value}
										/>
										<span>{el.label}</span>
									</label>
								))}
							</td>
						</tr>
						<tr>
							{/**배송비*/}
							<th>배송비</th>
							<td>
								<input type='text' value={TableData.deliveryFee || ''} onChange={(e) => handleInputChange(e, 'deliveryFee')} />원
							</td>
						</tr>
						<tr>
							{/**제주 추가 배송비*/}
							<th>제주 추가 배송비</th>
							<td>
								<input type='text' value={TableData.jejuDeliveryFee || ''} onChange={(e) => handleInputChange(e, 'jejuDeliveryFee')} />원
							</td>
						</tr>
						<tr>
							{/**도서산간 추가 배송비*/}
							<th>도서산간 추가 배송비</th>
							<td>
								<input type='text' value={TableData.islandDeliveryFee || ''} onChange={(e) => handleInputChange(e, 'islandDeliveryFee')} />원
							</td>
						</tr>
						<tr>
							{/**지역벽 차등 배송비*/}
							<th>지역벽 차등 배송비</th>
							<td>
								<input
									type='text'
									value={TableData.differentialDeliveryFee || ''}
									onChange={(e) => handleInputChange(e, 'differentialDeliveryFee')}
									placeholder='ex)제주도 5,000원 도서산간 7,000원 추가'
								/>
							</td>
						</tr>
						<tr>
							{/**반품배송비(편도)*/}
							<th>반품배송비(편도)</th>
							<td>
								<input type='text' value={TableData.returnDeliveryFee || ''} onChange={(e) => handleInputChange(e, 'returnDeliveryFee')} />원
							</td>
						</tr>
						<tr>
							{/**교환배송비(왕복)*/}
							<th>교환배송비(왕복)</th>
							<td>
								<input type='text' value={TableData.exchangeDeliveryFee || ''} onChange={(e) => handleInputChange(e, 'exchangeDeliveryFee')} />원
							</td>
						</tr>
						<tr>
							{/**A/S전화번호*/}
							<th>A/S전화번호</th>
							<td>
								<input type='text' value={TableData.ASphoneNumber || ''} onChange={(e) => handleInputChange(e, 'ASphoneNumber')} placeholder='010-0000-0000' />
							</td>
						</tr>
						<tr>
							{/**A/S안내*/}
							<th>A/S안내</th>
							<td>
								<input type='text' value={TableData.ASinfo || ''} onChange={(e) => handleInputChange(e, 'ASinfo')} />
							</td>
						</tr>
						<tr>
							{/**복수구매할인*/}
							<th>복수구매할인</th>
							<td>
								<label>
									<input
										type='checkbox'
										value={TableData.buysDiscount}
										checked={TableData.buysDiscount}
										onChange={(e) => {
											handleSingleCheck(e, 'buysDiscount');
										}}
									/>
									<span>설정함</span>
								</label>
							</td>
						</tr>
						<tr>
							{/**포인트*/}
							<th>포인트</th>
							<td>
								<CheckBox
									itemList={['상품 구매 시 지급', '상품리뷰 작성시 지급']}
									getCheckedList={(checkedList) => handleMultiCheck(checkedList, 'point')}
									updateList={TableData.point}
									defaultCheckedList={[]}
									isAllCheck={false}
								/>
							</td>
						</tr>
						<tr>
							{/**무이자할부*/}
							<th>무이자할부</th>
							<td>
								<label>
									<input
										type='checkbox'
										value={TableData.installment}
										checked={TableData.installment}
										onChange={(e) => {
											handleSingleCheck(e, 'installment');
										}}
									/>
									<span>설정함</span>
								</label>
							</td>
						</tr>
						<tr>
							{/**이벤트*/}
							<th>이벤트</th>
							<td>
								<input type='text' value={TableData.event || ''} onChange={(e) => handleInputChange(e, 'event')} />
							</td>
						</tr>
						<tr>
							{/**Meta description*/}
							<th>Meta description</th>
							<td>
								<input type='text' value={TableData.metaDescription || ''} onChange={(e) => handleInputChange(e, 'metaDescription')} />
							</td>
						</tr>
						<tr>
							{/**가격비교 사이트 등록*/}
							<th>가격비교 사이트 등록</th>
							<td>
								{SiteList.length > 0 && (
									<CheckBox
										itemList={SiteList}
										getCheckedList={(checkedList) => handleMultiCheck(checkedList, 'site')}
										updateList={TableData.site}
										defaultCheckedList={['네이버쇼핑']}
										isAllCheck={false}
									/>
								)}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}
